module.exports = "/static/assets/783d87a11d87b2c498242905634a62e4.png";